// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDependentResponseDto
 */
export interface IDependentResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IDependentResponseDto
     */
    dependent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IDependentResponseDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    middle_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    suffix?: string;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    gender_type?: IDependentResponseDtoGenderTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IDependentResponseDto
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    relationship_type?: IDependentResponseDtoRelationshipTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    creation_source_type?: IDependentResponseDtoCreationSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IDependentResponseDto
     */
    status?: IDependentResponseDtoStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IDependentResponseDtoGenderTypeEnum {
    M = 'M',
    F = 'F',
    O = 'O'
}
/**
* @export
* @enum {string}
*/
export enum IDependentResponseDtoRelationshipTypeEnum {
    SPOUSE = 'SPOUSE',
    CHILD = 'CHILD',
    DOMESTIC_PARTNER = 'DOMESTIC_PARTNER',
    OTHER = 'OTHER'
}
/**
* @export
* @enum {string}
*/
export enum IDependentResponseDtoCreationSourceTypeEnum {
    UNKNOWN = 'UNKNOWN',
    API = 'API',
    MOBILE = 'MOBILE',
    WEB_PARTICIPANT_PORTAL = 'WEB_PARTICIPANT_PORTAL',
    WEB_ADMIN_PORTAL = 'WEB_ADMIN_PORTAL',
    DEPENDENT = 'DEPENDENT',
    CARRIER = 'CARRIER',
    CENSUS = 'CENSUS'
}
/**
* @export
* @enum {string}
*/
export enum IDependentResponseDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}


/**
 * Check if a given object implements the IDependentResponseDto interface.
 */
export function instanceOfIDependentResponseDto(value: object): value is IDependentResponseDto {
    return true;
}

export function IDependentResponseDtoFromJSON(json: any): IDependentResponseDto {
    return IDependentResponseDtoFromJSONTyped(json, false);
}

export function IDependentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDependentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'dependent_id': json['dependent_id'] == null ? undefined : json['dependent_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'gender_type': json['gender_type'] == null ? undefined : json['gender_type'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'relationship_type': json['relationship_type'] == null ? undefined : json['relationship_type'],
        'creation_source_type': json['creation_source_type'] == null ? undefined : json['creation_source_type'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function IDependentResponseDtoToJSON(json: any): IDependentResponseDto {
    return IDependentResponseDtoToJSONTyped(json, false);
}

export function IDependentResponseDtoToJSONTyped(value?: IDependentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dependent_id': value['dependent_id'],
        'employee_id': value['employee_id'],
        'ssn': value['ssn'],
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'gender_type': value['gender_type'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'relationship_type': value['relationship_type'],
        'creation_source_type': value['creation_source_type'],
        'status': value['status'],
    };
}

